import request from '@/utils/request'

export function getToken(data){
    return request({
        url: '/auth/tokenInfo',
        method: 'post',
        params:data
      })
}
export function login(data){
    return request({
        url: '/auth/doLogin',
        method: 'post',
        data:data,
        // 供 axios 攔截器可靠辨識「登入請求」（避免 config.url 經代理後無法匹配 /auth/doLogin 而誤判為 session 過期）
        xrrossLoginAttempt: true
      })
}
export function userInfo(){
  return request({
      url: '/auth/getUserInfo',
      method: 'get',
      params:null
    })
}



// WEBPACK FOOTER //
// C:/Users/xiaolan/Desktop/Android/Xrross-SOC-Frontend/E:/xrross/Android/Xrross-SOC-Frontend/src/api/login.js